// project import
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';
import useConfig from 'hooks/useConfig';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  const { i18n } = useConfig();
  return (
    <SimpleBar
      sx={{
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <Navigation key={i18n} />
    </SimpleBar>
  );
};

export default DrawerContent;
